import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        publishedEforms: {
            paginator: {
                rowsByPage: "Resultados por página",
            }
        },
        userActive: {
            dni: "Cédula de identidad",
            numero_legajo_aprobador: "Nombre del aprobador",
        },
        label: {
            dni: "Número de documento",
        },
        ei_titleList_text_1_3: "Cédula de identidad *",
        head_text_table_search_3: "Cédula de identidad",
        employees_list_search_desc: "Para realizar una búsqueda puede ingresar el Nombre, Apellido, Cédula de identidad o Email del empleado en el campo de búsqueda o seleccionar una combinación de filtros.",
        search_text_1_1: "Cédula de identidad, Nombre, Apellido o Email",
        split_crop_and_sign: {
            modalSignAndPublish: {
                labelInput: "Contraseña",
            }
        },
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "Identificador",
                    question: "¿Cuál es el Identificador del colaborador?",
                    description: "Ingresa el Identificador del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "Documento",
                },
                dni: "Documento"
            }
        }
    }
})